import { render, staticRenderFns } from "./ProjectTissueSampleFormGroups.vue?vue&type=template&id=037a9b19"
import script from "./ProjectTissueSampleFormGroups.vue?vue&type=script&lang=js"
export * from "./ProjectTissueSampleFormGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports